import styles from '../index.module.css'

import cn from 'clsx'
import { format, isValid } from 'date-fns'
import React from 'react'

import type { PlaylistCurated } from 'types/playlist'

import { Flex, Text, Tooltip } from 'components/ds'

export const PlaylistInfoText = ({
  playlist,
}: {
  playlist: PlaylistCurated
}) => {
  const today = new Date()
  const playlistDate = playlist.date_created
  const parsed = playlistDate ? new Date(playlistDate) : null
  const formattedDate =
    parsed && isValid(parsed) ? format(parsed, 'P') : format(today, 'P')

  const curatedBy = playlist.curated_by || playlist?.business?.business_name

  return (
    <Flex gap="1" pt="4" direction="column">
      <Text
        size="1"
        trim="both"
        weight="bold"
        highContrast
        className={cn(styles.Text_SubText, styles.Text_Date)}
      >
        {formattedDate}
      </Text>
      <Tooltip
        side="bottom"
        content={
          <Flex direction="column" gap="1">
            <Text highContrast>{playlist.name}</Text>
            <Text highContrast className={styles.Text_Tooltip}>
              {curatedBy ? `Curated by ${curatedBy}` : 'Curated Playlist'}
            </Text>
          </Flex>
        }
      >
        <Text
          weight="medium"
          size="4"
          className={styles.Text}
          highContrast
          truncate
        >
          {playlist.name}
        </Text>
      </Tooltip>
      <Text size="3" highContrast className={styles.Text_SubText} truncate>
        {curatedBy ? `Curated by ${curatedBy}` : 'Curated Playlist'}
      </Text>
    </Flex>
  )
}
